// Message types for internal messaging system

export interface Message {
  id: string;
  fromUserId: string;
  fromUserName: string;
  fromUserPhotoURL?: string;
  fromUserRole: string;
  toUserId: string;
  toUserName: string;
  subject: string;
  content: string;
  // שדות אופציונליים לקבצים מצורפים (תמונות / מסמכים קלים)
  attachmentUrl?: string;
  attachmentName?: string;
  attachmentType?: string; // image/png, application/pdf וכו'
  attachmentSize?: number; // bytes
  attachmentIsImage?: boolean;
  isRead: boolean;
  isDelivered?: boolean;
  isDeleted?: boolean;
  createdAt: string;
  deliveredAt?: string;
  readAt?: string;
  deletedAt?: string;
  editedAt?: string;
  isEdited?: boolean;
  replyToMessageId?: string; // For threading
  isSent?: boolean; // האם זו הודעה ששלחתי או קיבלתי
  conversationId?: string;
  conversationType?: 'direct' | 'group';
  conversationTitle?: string;
}

export const GROUP_MESSAGE_TO_USER_ID = '__group__';

export interface MessageConversationMeta {
  id: string;
  type: 'direct' | 'group';
  title: string;
  updatedAt: string;
  members: {
    userId: string;
    userName: string;
    userRole?: string;
    userPhotoURL?: string;
  }[];
}

export interface MessageThread {
  id: string;
  subject: string;
  participants: {
    userId: string;
    userName: string;
    userRole: string;
  }[];
  lastMessage: Message;
  unreadCount: number;
  updatedAt: string;
}

export interface UnreadCount {
  userId: string;
  count: number;
}

